import { toDisposable } from './disposable'

const EMPTY = []

// Named UI mounting points. Plugins contribute React components; the host (or
// a plugin that defined its own slot) renders them with <Slot name>.
export class SlotRegistry {
  #slots = new Map() // name -> { contributions: Map<key, entry>, snapshot: entry[]|null }
  #listeners = new Map() // name -> Set<cb>
  #seq = 0

  #slot(name) {
    let slot = this.#slots.get(name)
    if (!slot) {
      slot = { contributions: new Map(), snapshot: EMPTY }
      this.#slots.set(name, slot)
    }
    return slot
  }

  #notify(name, slot) {
    // cache the sorted snapshot: useSyncExternalStore needs a stable reference
    slot.snapshot = [...slot.contributions.values()].sort(
      (a, b) => a.order - b.order
    )
    for (const cb of this.#listeners.get(name) ?? []) cb()
  }

  addToSlot(name, component, { order = 0, key, pluginId } = {}) {
    const slot = this.#slot(name)
    const k = key ?? `auto-${++this.#seq}`
    slot.contributions.set(k, { component, order, pluginId, key: k })
    this.#notify(name, slot)
    return toDisposable(() => {
      slot.contributions.delete(k)
      this.#notify(name, slot)
    })
  }

  defineSlot(name) {
    this.#slot(name)
    return toDisposable(() => {})
  }

  getContributions(name) {
    return this.#slots.get(name)?.snapshot ?? EMPTY
  }

  subscribe(name, cb) {
    let set = this.#listeners.get(name)
    if (!set) {
      set = new Set()
      this.#listeners.set(name, set)
    }
    set.add(cb)
    return toDisposable(() => set.delete(cb))
  }
}
